import React, {useEffect, useState} from 'react'
import {Navigate} from 'react-router-dom'
import {Container} from 'semantic-ui-react'
import {useAuth} from '../context/AuthContext'
import {tripApi} from '../misc/TripApi'
import {handleLogError} from '../misc/Helpers'
import MyMessages from "./MyMessages";

function Inbox() {
  const Auth = useAuth()
  const user = Auth.getUser()
  const isUser = user.role === 'USER'

  const [currentUsertrips, setCurrentUsertrips] = useState([])
  const [oldUsertrips, setOldUsertrips] = useState([])
  const [currentDrivertrips, setCurrentDrivertrips] = useState([])
  const [oldDrivertrips, setOldDrivertrips] = useState([])
  const [isTripsLoading, setIsTripsLoading] = useState(false)

  useEffect(() => {
    handleGetUsertrips()
  }, [])


  const handleGetUsertrips = async () => {
    try {
      setIsTripsLoading(true)
      const currentUsertrips = await tripApi.getCurrentUsertrips(user)
      setCurrentUsertrips(currentUsertrips.data)
      const oldUsertrips = await tripApi.getOldUsertrips(user)
      setOldUsertrips(oldUsertrips.data)
      const currentDrivertrips = await tripApi.getCurrentDrivertrips(user)
      setCurrentDrivertrips(currentDrivertrips.data)
      const oldDrivertrips = await tripApi.getOldDrivertrips(user)
      setOldDrivertrips(oldDrivertrips.data)
    } catch (error) {
      handleLogError(error)
    } finally {
      setIsTripsLoading(false)
    }
  }

  const approve = async (id) => {
    const usertrip = await tripApi.approveUsertrip(user, id)
    const currentDrivertrips = await tripApi.getCurrentDrivertrips(user)
    setCurrentDrivertrips(currentDrivertrips.data)
  }

  const reject = async (id) => {
    const usertrip = await tripApi.rejectUsertrip(user, id)
    const currentDrivertrips = await tripApi.getCurrentDrivertrips(user)
    setCurrentDrivertrips(currentDrivertrips.data)
  }

  if (!isUser) {
    return <Navigate to='/'/>
  }

  return (
    <Container>
      <MyMessages
        isTripsLoading={isTripsLoading}
        currentUsertrips={currentUsertrips}
        oldUsertrips={oldUsertrips}
        currentDrivertrips={currentDrivertrips}
        oldDrivertrips={oldDrivertrips}
        approve={approve}
        reject={reject}
      />
    </Container>
  )
}

export default Inbox
